export const LiquidHookDynamicFeeV2Abi = [
  {
    type: "function",
    name: "liquidIsToken0",
    inputs: [{ name: "", type: "bytes32" }],
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "poolConfigVars",
    inputs: [{ name: "poolId", type: "bytes32" }],
    outputs: [
      {
        name: "",
        type: "tuple",
        components: [
          { name: "baseFee", type: "uint24" },
          { name: "maxLpFee", type: "uint24" },
          { name: "referenceTickFilterPeriod", type: "uint256" },
          { name: "resetPeriod", type: "uint256" },
          { name: "resetTickFilter", type: "int24" },
          { name: "feeControlNumerator", type: "uint256" },
          { name: "decayFilterBps", type: "uint24" },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "poolFeeVars",
    inputs: [{ name: "poolId", type: "bytes32" }],
    outputs: [
      {
        name: "",
        type: "tuple",
        components: [
          { name: "referenceTick", type: "int24" },
          { name: "resetTick", type: "int24" },
          { name: "resetTickTimestamp", type: "uint256" },
          { name: "lastSwapTimestamp", type: "uint256" },
          { name: "appliedVR", type: "uint24" },
          { name: "prevVA", type: "uint24" },
        ],
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "poolCreationTimestamp",
    inputs: [{ name: "", type: "bytes32" }],
    outputs: [{ name: "", type: "uint256" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "protocolFee",
    inputs: [],
    outputs: [{ name: "", type: "uint24" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "factory",
    inputs: [],
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "poolManager",
    inputs: [],
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "locker",
    inputs: [],
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "mevModule",
    inputs: [{ name: "", type: "bytes32" }],
    outputs: [{ name: "", type: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "mevModuleEnabled",
    inputs: [{ name: "", type: "bytes32" }],
    outputs: [{ name: "", type: "bool" }],
    stateMutability: "view",
  },
] as const;
